import React from "react";

import Profile from "components/Tvendo/Setting/User/Mantenance/Profile";

export default function () {
  return <Profile />;
}
